export class ServiceWorkerNotActiveError extends Error {
  constructor(message?: string) {
    super(message);
    this.name = "ServiceWorkerNotActiveError";
    Object.setPrototypeOf(this, ServiceWorkerNotActiveError.prototype);
  }
}

export class NotificationPermissionError extends Error {
  constructor(message?: string) {
    super(message);
    this.name = "NotificationPermissionError";
    Object.setPrototypeOf(this, NotificationPermissionError.prototype);
  }
}

export class GetTokenError extends Error {
  constructor(message?: string) {
    super(message);
    this.name = "GetTokenError";
    Object.setPrototypeOf(this, GetTokenError.prototype);
  }
}

export class RegisterTokenError extends Error {
  constructor(message?: string) {
    super(message);
    this.name = "RegisterTokenError";
    Object.setPrototypeOf(this, RegisterTokenError.prototype);
  }
}

declare module "@vue/runtime-core" {
  interface ComponentCustomProperties {}
}
